import type {RoadmapAudience} from './queryParams';

export interface PersonalizedRoadmapDatasetScope {
  assignee: 'all' | 'me';
  assigneeScopeEmployeeId: string | null;
}

export type RoadmapPersonLookupState = 'not_applicable' | 'loading' | 'resolved' | 'not_found';

export interface RoadmapContentQueryKeySelection {
  assignee: 'all' | 'me' | null;
  assigneeScopeEmployeeId: string | null;
  timeframe: string | null;
  scopeKey: string | null;
  groupTeamId: string | null;
  groupIds: readonly string[];
  quarter: string;
}

export const getRoadmapContentQueryKey = (
  content: 'launches' | 'rollup',
  selection: RoadmapContentQueryKeySelection
) =>
  [
    'roadmap',
    content,
    selection.assignee,
    selection.assigneeScopeEmployeeId,
    selection.timeframe,
    selection.scopeKey,
    selection.groupTeamId,
    selection.groupIds,
    selection.quarter,
  ] as const;

export const getPersonalizedRoadmapDatasetScope = (
  requestedAudience: RoadmapAudience,
  selectedPersonEmployeeId: string | null
): PersonalizedRoadmapDatasetScope | null => {
  if (requestedAudience === 'my') {
    return {
      assignee: 'me',
      assigneeScopeEmployeeId: null,
    };
  }
  if (requestedAudience === 'person' && selectedPersonEmployeeId) {
    return {
      assignee: 'all',
      assigneeScopeEmployeeId: selectedPersonEmployeeId,
    };
  }
  return null;
};

export const getRoadmapPersonLookupState = (
  requestedAudience: RoadmapAudience,
  lookupLoading: boolean,
  selectedPersonEmployeeId: string | null
): RoadmapPersonLookupState => {
  if (requestedAudience !== 'person') return 'not_applicable';
  if (selectedPersonEmployeeId) return 'resolved';
  return lookupLoading ? 'loading' : 'not_found';
};

export const shouldLoadUnpersonalizedRoadmapDataset = ({
  requestedAudience,
  hasExplicitAudienceSelection,
  myRoadmapItemCount,
}: {
  requestedAudience: RoadmapAudience;
  hasExplicitAudienceSelection: boolean;
  myRoadmapItemCount: number | null;
}): boolean => {
  if (requestedAudience !== 'my' && requestedAudience !== 'person') return true;
  return requestedAudience === 'my' && !hasExplicitAudienceSelection && myRoadmapItemCount === 0;
};
